import './footer.css';
import { IListing } from "../../../models/listing.model";

export interface FooterProps {
  listing: IListing;
}

export const Footer = (props: FooterProps) => {

  return (
    <div className="footer">
      <div>
        The trademarks REALTOR®, REALTORS®, and the REALTOR® logo are controlled by The Canadian Real Estate Association (CREA) and identify real estate professionals who are members of CREA. The trademarks MLS®, Multiple Listing Service® and the associated logos are owned by CREA and identify the quality of services provided by real estate professionals who are members of CREA. Used under license.
      </div>
      <div>
        TRREB IDX information is provided exclusively for consumers’ personal, non-commercial use, that it may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing, and that data is deemed reliable but is not guaranteed accurate by the MLS®.
      </div>
    </div>
  );
}
